'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _bluebird = require('bluebird');

var _bluebird2 = _interopRequireDefault(_bluebird);

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

var _klass = require('klass');

var _klass2 = _interopRequireDefault(_klass);

var _events = require('events');

var _events2 = _interopRequireDefault(_events);

var _s3upload = require('react-s3-uploader/s3upload.js');

var _s3upload2 = _interopRequireDefault(_s3upload);

var _sanitizeFilename = require('sanitize-filename');

var _sanitizeFilename2 = _interopRequireDefault(_sanitizeFilename);

var _ApiClient = require('./ApiClient');

var _ApiClient2 = _interopRequireDefault(_ApiClient);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var EventEmitter = _events2.default.EventEmitter;

var S3FileUploader = (0, _klass2.default)({
  initialize: function initialize(file, options) {
    this.file = file;
    this.preview = file.preview || URL.createObjectURL(file);
    this.emitter = new EventEmitter();
    this.opts = _lodash2.default.defaults(options || {}, {
      signingUrl: '/s3/sign',
      uploadRequestHeaders: { 'x-amz-acl': 'public-read' },
      signingUrlQueryParams: {
        objectName: Date.now()
      },
      accept: 'image/*',
      server: _ApiClient2.default.getS3SigningBaseUrl()
    });
  },
  getFile: function getFile() {
    return this.file;
  },
  getFileType: function getFileType() {
    return this.getFile().type;
  },
  getPreview: function getPreview() {
    return this.preview;
  },
  getFilename: function getFilename() {
    return this.getFile().name;
  },
  isImage: function isImage() {
    return (/^image\//.exec(this.getFileType())
    );
  },
  getResultS3Filename: function getResultS3Filename() {
    return this.result && this.result.filename;
  },
  getPublicUrl: function getPublicUrl() {
    return this.result && this.result.publicUrl;
  },
  on: function on(event, callback) {
    this.emitter.addListener(event, callback);
  },
  off: function off(event, callback) {
    this.emitter.removeListener(event, callback);
  },
  cancel: function cancel() {
    if (this.upload) {
      this.upload.abortUpload();
      this.emitter.emit('abort');
      this.upload = null;
    }
  },
  markFailed: function markFailed() {
    this.failed = true;
  },
  isFailed: function isFailed() {
    return !!this.failed;
  },
  getContentDisposition: function getContentDisposition() {
    var isPdf = this.getFileType() == 'application/pdf';
    return isPdf ? 'inline' : 'auto';
  },
  start: function start() {
    var _this = this;

    return new _bluebird2.default(function (resolve, reject) {
      _this.upload = new _s3upload2.default({
        files: [_this.file],
        signingUrl: _this.opts.signingUrl,
        uploadRequestHeaders: _this.opts.uploadRequestHeaders,
        accept: _this.opts.accept,
        server: _this.opts.server,
        signingUrlQueryParams: _this.opts.signingUrlQueryParams,
        contentDisposition: _this.getContentDisposition(),
        onProgress: function onProgress(percent, status) {
          console.log('onProgress', percent, status);
          _this.emitter.emit('progress', percent, status);
        },
        onFinishS3Put: function onFinishS3Put(result) {
          console.log('onFinishS3Put', result);
          _this.result = result;
          _this.emitter.emit('complete', result);
          resolve(result);
        },
        onError: function onError(status) {
          console.log('onError', status);
          _this.emitter.emit('error', status);
          _this.markFailed();
          reject(status);
        }
      });
      _this.emitter.once('abort', resolve);
    });
  }
});

exports.default = S3FileUploader;
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./src/helpers/S3FileUploader.js
 ** module id = 457
 ** module chunks = 0
 **/